import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { lifecycle, compose } from 'recompose'
import { connect } from 'react-redux'
import { getUserId, isFetchSessionInProgress } from '../../services/session'
import { isSocketConnected } from '../../services/connection/'
import Loading from '../views/loading'

export const LayoutSimple = props => (
  <div className={'app-wrapper ' + props.theme}>
    {props.isLoading ? <Loading /> : props.children}
  </div>
)

LayoutSimple.propTypes = {
  theme: PropTypes.oneOf(['gradient-theme', 'dark-theme', 'light-theme']),
  isLoading: PropTypes.bool
}

LayoutSimple.defaultProps = {
  theme: 'dark-theme'
}

const redirectIfLoggedIn = lifecycle({
  componentDidMount: function() {
    if (this.props.userId) {
      this.props.history.replace('/explore')
    }
  }
})

function mapStateToProps(state) {
  return {
    isLoading: !isSocketConnected(state) || isFetchSessionInProgress(state),
    userId: getUserId(state)
  }
}

const decorate = compose(
  connect(mapStateToProps),
  withRouter,
  redirectIfLoggedIn
)

export default decorate(LayoutSimple)



// WEBPACK FOOTER //
// ./src/ui/shared/layout-simple.js